
import {getWithdrawalsUser} from '../api/getWithdrawalsUser';
import {setGetWithdrawalsUserAction} from '../action';

const setGetWithdrawalsUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getWithdrawalsUser(params);
            
            if (data.status === 'success') {
                dispatch(setGetWithdrawalsUserAction({
                    data: data.data,
                    count: data.count
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetWithdrawalsUser
}